import { IScenario } from "../types/IScenario";
import { GuidGenerator } from "../utils/guidGenerator";

const PLAYER_NAME_KEY = 'MAFIA_PLAYER_NAME';
const SERVER_NAME = 'MAFIA_SERVER_NAME';
const MAFIA_UID = 'MAFIA_UID'
const MAFIA_SCENARIOS = 'MAFIA_SCENARIOS';

export default class LocalStorageService {
    public static SetName = (name: string) => localStorage.setItem(PLAYER_NAME_KEY, name);
    public static SetServer = (server: string) => localStorage.setItem(SERVER_NAME, server);
    public static GenerateGuid = (): string => {
        const guid = GuidGenerator.generateGUID();
        localStorage.setItem(MAFIA_UID, guid);
        return guid;
    };

    public static GetName = () => localStorage.getItem(PLAYER_NAME_KEY);
    public static GetServer = () => localStorage.getItem(SERVER_NAME);
    public static GetUid = () => localStorage.getItem(MAFIA_UID);


    public static SaveScenarios = (scenarios: IScenario[]) => {
        localStorage.setItem(MAFIA_SCENARIOS, JSON.stringify(scenarios));
    }

    public static GetScenarios = (): IScenario[] => {
        const storageData = localStorage.getItem(MAFIA_SCENARIOS);
        if(storageData){
            return JSON.parse(storageData) as IScenario[];
        }
        return [];
    }
}